import { Button, Form } from "devextreme-react";
import { GroupItem, SimpleItem } from "devextreme-react/form";
import moment from "moment";
import { forwardRef, useRef } from "react";
import { useSelector } from "react-redux";
import { getApiParams } from "../../redux/auth";
import { BodyType, createRequest } from "../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga";
import { getLocalized } from "../../redux/localization";
import { User } from "../dashboard/product-comment/type";
import { renderInformationItem } from "../productRequestPage/detail";
import { Contract, ContractMessage } from "./type";

const ContractDetail = forwardRef<any, { data: Contract, user?: User }>(
    ({ data, user }, ref
    ) => {
        const localize = useSelector(getLocalized);
        const { token, lang } = useSelector(getApiParams);
        const messageRef = useRef<any>();
        const message = useRef<ContractMessage>({
            contractId: "",
            message: ""
        })

        const getUserInfo = () => {
            window.open(`/#/account-details/${user?.AccountId}`)
        }
        const sendMessage = async () => {
            message.current.contractId = data.Id
            const response: ApiResponse<ContractMessage> = await createRequest({
                method: "POST",
                url: "api/admin/admincontracts/add-message/",
                bodyType: BodyType.raw,
                token,
                body: message.current,
                lang,
            });
            if (verfiyResponse(response)) {
                messageRef.current.instance.resetValues();

            }
        }
        return (
            <div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >
                </div>
                <Form
                    ref={ref}
                    key="id"
                    labelLocation="left"
                    formData={data}
                    showColonAfterLabel={true}
                >
                    <GroupItem caption={localize.getString("contractDetail")} colCount={2}>
                        <GroupItem>
                            <SimpleItem
                                dataField="Code"
                                label={{
                                    text: localize.getString("code")
                                }}
                                render={renderInformationItem}
                            >
                            </SimpleItem>
                            <SimpleItem
                                dataField={"StartDate"}
                                label={{
                                    text: localize.getString("startDate")
                                }}
                                editorType="dxDateBox"
                                editorOptions={{
                                    dateSerializationFormat: "yyyy-MM-dd"
                                }}
                                render={
                                    (item: any) => {
                                        if (item.editorOptions.value !== null) {
                                            return <span>{moment.utc(item.editorOptions.value).format("l")}</span>;
                                        } else {
                                            return <span>-</span>;
                                        }
                                    }
                                }
                            >
                            </SimpleItem>
                            <SimpleItem
                                dataField={"EndDate"}
                                label={{
                                    text: localize.getString("endDate")
                                }}
                                editorType="dxDateBox"
                                editorOptions={{
                                    dateSerializationFormat: "yyyy-MM-dd"
                                }}
                                render={
                                    (item: any) => {
                                        if (item.editorOptions.value !== null) {
                                            return <span>{moment.utc(item.editorOptions.value).format("l")}</span>;
                                        } else {
                                            return <span>-</span>;
                                        }
                                    }
                                }
                            >
                            </SimpleItem>
                            <SimpleItem
                                dataField={"ContractStatusType"}
                                label={{
                                    text: localize.getString("contractStatusType")
                                }}
                                render={renderInformationItem}
                            >
                            </SimpleItem>
                            <SimpleItem
                                dataField={"Amount"}
                                label={{
                                    text: localize.getString("amount")
                                }}
                                render={renderInformationItem}
                            >
                            </SimpleItem>
                        </GroupItem>
                        <GroupItem>
                            <SimpleItem
                                dataField={`${message.current.message}`}
                                label={{
                                    text: localize.getString("message")
                                }}
                                render={renderInformationItem}
                            >
                            </SimpleItem>
                            <SimpleItem
                                dataField={"MessageDate"}
                                label={{
                                    text: localize.getString("messageDate")
                                }}
                                editorType="dxDateBox"
                                editorOptions={{
                                    dateSerializationFormat: "yyyy-MM-dd"
                                }}
                                render={
                                    (item: any) => {
                                        if (item.editorOptions.value !== null) {
                                            return <span>{moment.utc(item.editorOptions.value).format("l")}</span>;
                                        } else {
                                            return <span>-</span>;
                                        }
                                    }
                                }
                            >
                            </SimpleItem>
                            <GroupItem colCount={2}>
                                <Form
                                    ref={messageRef}
                                    key="id"
                                    labelLocation="left"
                                    formData={message.current}
                                    showColonAfterLabel={true}
                                >
                                    <SimpleItem
                                        editorType={"dxTextBox"}
                                        dataField={"message"}
                                        editorOptions={{
                                            inputAttr: {
                                                placeHolder: "Mesaj Giriniz.."
                                            },
                                        }}
                                    >
                                    </SimpleItem>
                                    <SimpleItem>
                                        <Button
                                            type="success"
                                            text="Gönder"
                                            onClick={() => sendMessage()}
                                        >
                                        </Button>
                                    </SimpleItem>
                                </Form>
                            </GroupItem>
                        </GroupItem>
                    </GroupItem>

                    <GroupItem colCount={2}>
                        <SimpleItem
                            dataField="UserName"
                            label={{
                                text: localize.getString("username")
                            }}
                            render={renderInformationItem}
                        >
                        </SimpleItem>
                        <SimpleItem>
                            <Button icon="arrowright" onClick={() => {
                                getUserInfo()
                            }}></Button>
                        </SimpleItem>
                    </GroupItem>
                    <GroupItem colCount={2}>
                        <SimpleItem
                            dataField="Product.Name"
                            label={{
                                text: localize.getString("productCardName")
                            }}
                            render={renderInformationItem}
                        >
                        </SimpleItem>
                        <SimpleItem>
                            <Button icon="arrowright" onClick={() => {
                                window.open(`/#/product-details/${data.Product.Id}`)
                            }}></Button>
                        </SimpleItem>
                    </GroupItem>
                    <GroupItem caption={localize.getString("customer")}>
                        <SimpleItem
                            dataField={"CustomerUser.Name"}
                            label={{
                                text: localize.getString("customerName")
                            }}
                            render={renderInformationItem}
                        >
                        </SimpleItem>
                        <SimpleItem
                            dataField={"CustomerUser.Surname"}
                            label={{
                                text: localize.getString("customerSurname")
                            }}
                            render={renderInformationItem}
                        >
                        </SimpleItem>
                        <SimpleItem
                            dataField={"CustomerUser.Email"}
                            label={{
                                text: localize.getString("email")
                            }}
                            render={renderInformationItem}
                        >
                        </SimpleItem>
                        <SimpleItem
                            dataField={"CustomerUser.Phone"}
                            label={{
                                text: localize.getString("phone")
                            }}
                            render={renderInformationItem}
                        >
                        </SimpleItem>
                    </GroupItem>
                    <GroupItem caption={localize.getString("supplier")}>
                        <SimpleItem
                            dataField={"SupplierAccount.AccountName"}
                            label={{
                                text: localize.getString("supplierName")
                            }}
                            render={renderInformationItem}
                        >
                        </SimpleItem>
                        <SimpleItem
                            dataField={"SupplierAccount.Email"}
                            label={{
                                text: localize.getString("email")
                            }}
                            render={renderInformationItem}
                        >
                        </SimpleItem>
                        <SimpleItem
                            dataField={"SupplierAccount.Phone"}
                            label={{
                                text: localize.getString("phone")
                            }}
                            render={renderInformationItem}
                        >
                        </SimpleItem>
                    </GroupItem>
                </Form>
            </div>
        )
    }
)

export default ContractDetail